import { ComponentType } from 'react';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import MarketingConsent from './MarketingConsent';

export interface TermsItem {
    title: string;
    Component: ComponentType;
}

export const TERMS_CONTENT: Record<string, TermsItem> = {
    service: {
        title: '이용약관',
        Component: TermsOfService,
    },
    privacy: {
        title: '개인정보 수집 이용 및 제공 동의',
        Component: PrivacyPolicy,
    },
    marketing: {
        title: '마케팅 정보 수신 동의',
        Component: MarketingConsent,
    },
};
